const mr = {
    "gui.menuBar.file": "फाइल",
    "gui.menuBar.edit": "संपादित करा",
    "gui.menuBar.new": "नवीन",
    "gui.menuBar.saveNow": "आता जतन करा",
    "gui.menuBar.saveAsCopy": "प्रत म्हणून जतन करा",
    "gui.menuBar.remix": "रीमिक्स",
    "gui.menuBar.languageSelector": "भाषा निवड",
    "gui.menuBar.tutorialsLibrary": "ट्युटोरियल्स",
    "gui.menuBar.community": "खुला समुदाय",
    "gui.menuBar.wiki": "एजंट डाउनलोड करा",
    "gui.menuBar.restoreSprite": "स्प्राइट पुनर्स्थापित करा",
    "gui.menuBar.restoreSound": "ध्वनी पुनर्स्थापित करा",
    "gui.menuBar.restoreCostume": "कॉस्ट्यूम पुनर्स्थापित करा",
    "gui.menuBar.restore": "पुनर्स्थापित करा",
    "gui.menuBar.turboModeOff": "टर्बो मोड बंद करा",
    "gui.menuBar.turboModeOn": "टर्बो मोड चालू करा",
    "gui.menuBar.noDeviceSelected": "कोणतेही उपकरण निवडले नाही",
    "gui.menuBar.noConnection": "कनेक्शन नाही",
    "gui.menuBar.downloadToComputer": "कंप्यूटरवर डाउनलोड करा",
    "gui.menuBar.checkUpdate": "अपडेट तपासा",
    "gui.menuBar.installDriver": "ड्रायव्हर स्थापित करा",
    "gui.menuBar.clearCacheAndRestart": "कॅश साफ करा आणि पुन्हा सुरू करा",
    "gui.adblockModal.title": "विज्ञापन अवरोधक आढळला",
    "gui.adblockModal.body":
        "TIFStudio ला विज्ञापन अवरोधकाने ब्लॉक केले आहे. कृपया TIFStudio साठी विज्ञापन अवरोधक बंद करा.",
    "gui.adblockModal.reload": "पुन्हा लोड करा",
    "gui.alerts.createsuccess": "नवीन प्रकल्प तयार केला.",
    "gui.alerts.createcopysuccess": "प्रकल्पाची प्रत जतन केली.",
    "gui.alerts.createremixsuccess": "प्रकल्प रीमिक्स म्हणून जतन केला.",
    "gui.alerts.creating": "नवीन तयार करत आहे...",
    "gui.alerts.creatingCopy": "प्रकल्पाची प्रत तयार करत आहे...",
    "gui.alerts.creatingRemix": "प्रकल्पाचा रीमिक्स तयार करत आहे...",
    "gui.alerts.downloading": "डाउनलोड होत आहे...",
    "gui.alerts.loading": "लोड होत आहे...",
    "gui.alerts.saving": "जतन करत आहे...",
    "gui.alerts.savesuccess": "प्रकल्प जतन झाला.",
    "gui.alerts.savingError": "प्रकल्प जतन होऊ शकला नाही.",
    "gui.alerts.cloudInfo":
        "कृपया लक्षात घ्या, क्लाउड व्हेरिएबल फक्त संख्या स्वीकारतात, अक्षरे किंवा चिन्हे नाहीत.",
    "gui.alerts.cloudVariableFull": "क्लाउड व्हेरिएबलची मर्यादा पूर्ण झाली.",
    "gui.alerts.importedSvgTitle": "अपलोड केलेल्या SVG फाइलमध्ये समस्या",
    "gui.alerts.importedSvgMessage":
        "SVG फाइल लोड होऊ शकली नाही. ही वैध SVG फाइल आहे का?",
    "gui.alerts.importedSvgReset": "पुन्हा प्रयत्न करा",
    "gui.alerts.importedSvgCancel": "रद्द करा",
    "gui.alerts.uploadError": "अपलोड त्रुटी",
    "gui.alerts.uploadSuccess": "अपलोड यशस्वी",
    "gui.gui.addExtension": "एक्स्टेंशन जोडा",
    "gui.gui.code": "कोड",
    "gui.gui.backdrops": "पार्श्वभूमी",
    "gui.gui.costumes": "कॉस्ट्यूम्स",
    "gui.gui.sounds": "ध्वनी",
    "gui.gui.codeTab": "कोड",
    "gui.gui.costumesTab": "कॉस्ट्यूम्स",
    "gui.gui.backdropsTab": "पार्श्वभूमी",
    "gui.gui.soundsTab": "ध्वनी",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "कॅमेरा बंद करा",
    "gui.menu-bar.realtimeMode": "स्क्रॅच",
    "gui.menu-bar.programMode": "प्रोग्राम",
    "gui.hardwareConsole.send": "पाठवा",
    "gui.hardwareConsole.buadrate": "बॉड रेट",
    "gui.hardwareConsole.endOfLine": "लाइनचा शेवट",
    "gui.hardwareConsole.hexform": "हेक्स फॉर्म",
    "gui.hardwareConsole.autoScroll": "ऑटो स्क्रोल",
    "gui.hardwareHeader.upload": "अपलोड",
    "gui.stageHeader.codeStageSizeLarge": "मोठा स्टेज",
    "gui.stageHeader.codeStageSizeSmall": "लहान स्टेज",
    "gui.stageHeader.hideStage": "स्टेज लपवा",
    "gui.stageHeader.fullscreenControl": "पूर्ण स्क्रीन नियंत्रण",
    "gui.extensionLibrary.comingSoon": "लवकरच येत आहे",
    "gui.extensionLibrary.requires": "आवश्यक",
    "gui.extensionLibrary.collaboration": "सहकार्याने",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "उत्पादक",
    "gui.extensionLibrary.version": "आवृत्ती",
    "gui.extensionLibrary.author": "लेखक",
    "gui.extensionLibrary.programMode": "प्रोग्राम मोड",
    "gui.extensionLibrary.programLanguage": "प्रोग्राम भाषा",
    "gui.extensionLibrary.deviceLearnMore": "अधिक जाणून घ्या",
    "gui.extensionLibrary.extensionHelp": "मदत",
    "gui.extensionLibrary.Processing": "प्रक्रिया होत आहे...",
    "gui.extensionLibrary.loaded": "लोड झाले",
    "gui.extensionLibrary.notLoaded": "लोड झाले नाही",
    "gui.extensionLibrary.chooseAnExtension": "एक एक्स्टेंशन निवडा",
    "gui.library.filterPlaceholder": "शोधा",
    "gui.library.allTag": "सर्व",
    "gui.library.readMore": "अधिक वाचा",
    "gui.library.readLess": "कमी वाचा",
    "gui.loader.message1": "स्प्राइट तयार करत आहे...",
    "gui.loader.message2": "ध्वनी लोड करत आहे...",
    "gui.loader.message3": "कॉस्ट्यूम्स लोड करत आहे...",
    "gui.loader.message4": "एक्स्टेंशन लोड करत आहे...",
    "gui.loader.message5": "ब्लॉक्स तयार करत आहे...",
    "gui.loader.message6": "गणित करत आहे...",
    "gui.loader.message7": "लोड होत आहे...",
    "gui.loader.message8": "तयार करत आहे...",
    "gui.loader.headline": "प्रकल्प लोड होत आहे",
    "gui.loader.creating": "प्रकल्प तयार करत आहे",
    "gui.spriteLibrary.chooseASprite": "एक स्प्राइट निवडा",
    "gui.spriteLibrary.paintASprite": "पेंट",
    "gui.spriteLibrary.uploadASprite": "स्प्राइट अपलोड करा",
    "gui.spriteLibrary.surprise": "आश्चर्य",
    "gui.soundLibrary.chooseASound": "एक ध्वनी निवडा",
    "gui.soundLibrary.record": "रेकॉर्ड",
    "gui.soundLibrary.uploadASound": "ध्वनी अपलोड करा",
    "gui.costumeLibrary.chooseACostume": "एक कॉस्ट्यूम निवडा",
    "gui.costumeLibrary.paintACostume": "पेंट",
    "gui.costumeLibrary.uploadACostume": "कॉस्ट्यूम अपलोड करा",
    "gui.backdropLibrary.chooseABackdrop": "एक पार्श्वभूमी निवडा",
    "gui.backdropLibrary.paintABackdrop": "पेंट",
    "gui.backdropLibrary.uploadABackdrop": "पार्श्वभूमी अपलोड करा",
    "gui.spriteSelector.addSpriteFromLibrary": "एक स्प्राइट निवडा",
    "gui.spriteSelector.addSpriteFromPaint": "पेंट",
    "gui.spriteSelector.addSpriteFromSurprise": "आश्चर्य",
    "gui.spriteSelector.addSpriteFromFileUpload": "स्प्राइट अपलोड करा",
    "gui.stageSelector.addBackdropFromLibrary": "एक पार्श्वभूमी निवडा",
    "gui.stageSelector.addBackdropFromPaint": "पेंट",
    "gui.stageSelector.addBackdropFromSurprise": "आश्चर्य",
    "gui.stageSelector.addBackdropFromFileUpload": "पार्श्वभूमी अपलोड करा",
    "gui.stageSelector.stage": "स्टेज",
    "gui.stageSelector.backdrops": "पार्श्वभूमी",
    "gui.spriteSelectorItem.contextMenuDuplicate": "प्रत बनवा",
    "gui.spriteSelectorItem.contextMenuExport": "निर्यात करा",
    "gui.spriteSelectorItem.contextMenuDelete": "हटवा",
    "gui.spriteInfo.sprite": "स्प्राइट",
    "gui.spriteInfo.size": "आकार",
    "gui.spriteInfo.show": "दाखवा",
    "gui.spriteInfo.changeSize": "आकार बदला",
    "gui.spriteInfo.changeX": "X बदला",
    "gui.spriteInfo.changeY": "Y बदला",
    "gui.spriteInfo.direction": "दिशा",
    "gui.spriteInfo.changeDirection": "दिशा बदला",
    "gui.spriteInfo.isVisible": "दिसत आहे",
    "gui.deviceLibrary.chooseADevice": "एक उपकरण निवडा",
    "gui.deviceLibrary.deviceUrl": "डिव्हाइस URL प्रविष्ट करा",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microbitTag": "Micro:bit",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "किट",
    "gui.deviceLibrary.shieldTag": "शील्ड",
    "gui.playButton.play": "चालवा",
    "gui.playButton.stop": "थांबवा",
    "gui.gui.variableScopeOptionAllSprites": "सर्व स्प्राइट्ससाठी",
    "gui.gui.variableScopeOptionSpriteOnly": "फक्त या स्प्राइटसाठी",
    "gui.gui.cloudVariableOption": "क्लाउड व्हेरिएबल (सर्व्हरवर साठवलेले)",
    "gui.gui.variablePromptDefaultValue": "माझा व्हेरिएबल",
    "gui.gui.listVariable": "यादी तयार करा",
    "gui.gui.makeAVariable": "व्हेरिएबल तयार करा",
    "gui.gui.newVariable": "नवीन व्हेरिएबल",
    "gui.soundEditor.sound": "ध्वनी",
    "gui.soundEditor.play": "चालवा",
    "gui.soundEditor.stop": "थांबवा",
    "gui.soundEditor.copy": "कॉपी",
    "gui.soundEditor.paste": "पेस्ट",
    "gui.soundEditor.copyToNew": "नवीनमध्ये कॉपी करा",
    "gui.soundEditor.delete": "हटवा",
    "gui.soundEditor.save": "जतन करा",
    "gui.soundEditor.undo": "पूर्ववत करा",
    "gui.soundEditor.redo": "पुन्हा करा",
    "gui.soundEditor.faster": "जलद",
    "gui.soundEditor.slower": "हळू",
    "gui.soundEditor.echo": "प्रतिध्वनी",
    "gui.soundEditor.robot": "रोबोट",
    "gui.soundEditor.louder": "जोरात आवाज",
    "gui.soundEditor.softer": "मऊ आवाज",
    "gui.soundEditor.reverse": "उलट",
    "gui.soundEditor.fadeOut": "फेड आउट",
    "gui.soundEditor.fadeIn": "फेड इन",
    "gui.soundEditor.mute": "म्यूट",
    "paint.paintEditor.hue": "रंग",
    "paint.paintEditor.saturation": "सॅच्युरेशन",
    "paint.paintEditor.brightness": "प्रकाशमानता",
    "paint.paintEditor.fill": "भरा",
    "paint.paintEditor.costume": "कॉस्ट्यूम",
    "paint.paintEditor.group": "गट",
    "paint.paintEditor.ungroup": "गट तोडा",
    "paint.paintEditor.undo": "पूर्ववत करा",
    "paint.paintEditor.redo": "पुन्हा करा",
    "paint.paintEditor.forward": "समोर आणा",
    "paint.paintEditor.backward": "मागे पाठवा",
    "paint.paintEditor.front": "सर्वात समोर",
    "paint.paintEditor.back": "सर्वात मागे",
    "paint.paintEditor.more": "अधिक",
    "paint.modeTools.brushSize": "ब्रशचा आकार",
    "paint.modeTools.eraserSize": "इरेजरचा आकार",
    "paint.modeTools.copy": "कॉपी",
    "paint.modeTools.paste": "पेस्ट",
    "paint.modeTools.delete": "हटवा",
    "paint.modeTools.curved": "वक्र",
    "paint.modeTools.pointed": "नुकीला",
    "paint.modeTools.thickness": "जाडी",
    "paint.modeTools.flipHorizontal": "आडवे पलटवा",
    "paint.modeTools.flipVertical": "उभे पलटवा",
    "paint.modeTools.filled": "भरलेले",
    "paint.modeTools.outlined": "रूपरेषा",
    "paint.paintEditor.bitmap": "बिटमॅपमध्ये बदला",
    "paint.paintEditor.vector": "वेक्टरमध्ये बदला",
    "paint.paintEditor.stroke": "रूपरेषा",
    "paint.brushMode.brush": "ब्रश",
    "paint.eraserMode.eraser": "इरेजर",
    "paint.fillMode.fill": "भरा",
    "paint.lineMode.line": "रेषा",
    "paint.ovalMode.oval": "वर्तुळ",
    "paint.rectMode.rect": "आयत",
    "paint.reshapeMode.reshape": "आकार बदला",
    "paint.roundedRectMode.roundedRect": "गोल आयत",
    "paint.selectMode.select": "निवडा",
    "paint.textMode.text": "मजकूर",
    "paint.colorPicker.swap": "स्वॅप",
    "gui.uploadProgress.uploading": "अपलोड होत आहे",
    "gui.uploadProgress.uploadSuccess": "अपलोड यशस्वी",
    "gui.uploadProgress.uploadError": "अपलोड त्रुटी",
    "gui.uploadProgress.close": "बंद करा",
    "gui.uploadProgress.abort": "रद्द करा",
    "gui.connection.connect": "कनेक्ट करा",
    "gui.connection.disconnect": "डिस्कनेक्ट करा",
    "gui.connection.connected": "कनेक्टेड",
    "gui.connection.connecting": "कनेक्ट होत आहे...",
    "gui.connection.error": "त्रुटी",
    "gui.connection.unavailable": "उपलब्ध नाही",
    "gui.connection.noDevicesFound": "कोणतेही उपकरण सापडले नाही",
    "gui.connection.scanning": "स्कॅन करत आहे...",
    "gui.connection.help": "मदत",
    "gui.connection.refresh": "ताजे करा",
    "blockly.deleteBlock": "ब्लॉक हटवा",
    "blockly.duplicateBlock": "प्रत बनवा",
    "blockly.addComment": "टिप्पणी जोडा",
    "blockly.removeComment": "टिप्पणी काढा",
    "blockly.externalInput": "बाह्य इनपुट",
    "blockly.inlineInput": "इनलाइन इनपुट",
    "blockly.disableBlock": "ब्लॉक अक्षम करा",
    "blockly.enableBlock": "ब्लॉक सक्षम करा",
    "blockly.expandBlock": "ब्लॉक विस्तृत करा",
    "blockly.collapseBlock": "ब्लॉक संक्षिप्त करा",
    "blockly.help": "मदत",
    "blockly.undo": "पूर्ववत करा",
    "blockly.redo": "पुन्हा करा",
    "blockly.cleanUp": "ब्लॉक्स स्वच्छ करा",
    "blockly.sortByCategory": "श्रेणीनुसार क्रमबद्ध करा",
    "blockly.workspaceComment": "वर्कस्पेस टिप्पणी",
    "blockly.exportToHtml": "HTML म्हणून निर्यात करा",
    "blockly.snapToGrid": "ग्रिडवर चिकटवा",
    "blockly.cannotDeleteVariable": "हा व्हेरिएबल हटवता येत नाही",
    "blockly.renameVariable": "व्हेरिएबलचे नाव बदला",
    "blockly.newVariable": "नवीन व्हेरिएबल",
    "blockly.renameVariableTitle": 'सर्व "%1" व्हेरिएबल्सचे नाव बदला:',
    "blockly.variableAlreadyExists": '"%1" नावाचा व्हेरिएबल आधीच आहे',

    // Device translations
    "gui.device.unselectDevice.name": "उपकरण निवड रद्द करा",
    "gui.device.unselectDevice.description":
        "उपकरण निवड रद्द करा, शुद्ध रिअल-टाइम प्रोग्रामिंग मोडमध्ये परत जा.",
    "gui.device.connectingMessage": "कनेक्ट होत आहे",
    "gui.device.arduinoUno.description":
        "इलेक्ट्रॉनिक्स आणि कोडिंग शिकण्यासाठी उत्तम बोर्ड.",
    "gui.device.arduinoNano.description":
        "Arduino Nano ही लहान आणि क्लासिक बोर्ड आहे.",
    "gui.device.arduinoLeonardo.description":
        "क्लासिक Arduino बोर्ड जो माऊस किंवा कीबोर्ड म्हणून काम करू शकतो.",
    "gui.device.arduinoMega2560.description":
        "54 डिजिटल पिन, 16 अॅनालॉग इनपुट आणि 4 सिरियल पोर्ट असलेला 8-बिट बोर्ड.",
    "gui.device.arduinoUnoR4Minima.description":
        "उच्च कार्यक्षमता आणि अधिक मेमरी, विद्यमान शील्ड्सशी सुसंगत.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi आणि Bluetooth सह, ऑन-बोर्ड 12x8 LED मॅट्रिक्स.",
    "gui.device.esp32.description":
        "Wi-Fi आणि Bluetooth सह समृद्ध वैशिष्ट्ये असलेला बोर्ड.",
    "gui.device.esp32S3.description":
        "AI एक्सेलेरेटर आणि शक्तिशाली पेरीफेरल्ससह IoT आणि AI साठी.",
    "gui.device.esp8266NodeMCU.description":
        "कमी किंमतीचा Wi-Fi SOC नियंत्रण बोर्ड.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V चिपवर आधारित, सर्व IO पिन उपलब्ध.",
    "gui.device.k210Maixduino.description": "ESP32 सोबत K210 RISC-V बोर्ड.",
    "gui.device.raspberryPiPicoIconURL.description":
        "सोपे आणि वापरण्यास सुलभ मायक्रोकंट्रोलर बोर्ड.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "2.4 GHz Wi-Fi आणि Bluetooth 5.2 सोबत Pico.",
    "gui.device.raspberryPiPico2IconURL.description":
        "उच्च कार्यक्षमता ड्युअल-कोर MCU, अधिक RAM आणि फ्लॅश.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "2.4 GHz Wi-Fi आणि Bluetooth सोबत Pico 2.",
    "gui.device.microbit.description":
        "डिजिटल कौशल्य शिकण्यासाठी पॉकेट-साइज कॉम्प्युटर.",
    "gui.device.microbitV2.description":
        "उन्नत प्रोसेसर, स्पीकर, मायक्रोफोन आणि टच-सेंसिटिव्ह लोगो.",
    "gui.device.makeymakey.description": "कोणत्याही गोष्टीला की बनवा.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT हे ESP32-S3 आधारित बोर्ड आहे ज्यात Wi-Fi, Bluetooth आणि रोबोटिक्स व IoT प्रकल्पांसाठी समृद्ध peripherals आहेत.",
    "gui.device.lightWingDrone.description":
        "लाइट विंग ड्रोन हे अॅडव्हान्स्ड स्टेबिलायझेशन आणि Wi-Fi कंट्रोलसह उच्च-परफॉर्मन्स ESP32-S3 आधारित फ्लाइट कंट्रोलर आहे.",
    "gui.device.roboticDog.description":
        "Robotic Dog हे Arduino Nano ने चालवलेले एक स्मार्ट चौपाया रोबोट आहे, जे जीवंत हालचाली आणि अडथळे टाळण्यास सक्षम आहे.",
    "gui.device.roboticArm.description":
        "Robotic Arm हे Arduino Nano ने चालवलेले एक मल्टी-अॅक्सिस मॅनिप्युलेटर आहे, जे अचूक कार्ये आणि ऑटोमेशन शिकण्यासाठी डिझाइन केले आहे.",
    // Music
    "music.categoryName": "संगीत",
    "music.playDrumForBeats": "ड्रम [DRUM] [BEATS] बीट्ससाठी वाजवा",
    "music.restForBeats": "[BEATS] बीट्ससाठी थांबा",
    "music.playNoteForBeats": "नोट [NOTE] [BEATS] बीट्ससाठी वाजवा",
    "music.setInstrument": "वाद्य [INSTRUMENT] सेट करा",
    "music.changeTempo": "टेम्पो [TEMPO] ने बदला",
    "music.setTempo": "टेम्पो [TEMPO] वर सेट करा",
    "music.getTempo": "टेम्पो",
    "music.drumBass": "(2) बास ड्रम",
    "music.drumBongo": "(13) बोंगो",
    "music.drumCabasa": "(15) कबासा",
    "music.drumClaves": "(9) क्लेव्स",
    "music.drumClosedHiHat": "(6) बंद हाय-हॅट",
    "music.drumConga": "(14) कोंगा",
    "music.drumCowbell": "(11) काउबेल",
    "music.drumCrashCymbal": "(4) क्रॅश सिंबल",
    "music.drumCuica": "(18) कुइका",
    "music.drumGuiro": "(16) गुइरो",
    "music.drumHandClap": "(8) टाळी",
    "music.drumOpenHiHat": "(5) उघडी हाय-हॅट",
    "music.drumSideStick": "(3) साइड स्टिक",
    "music.drumSnare": "(1) स्नेअर ड्रम",
    "music.drumTambourine": "(7) डफली (Tambourine)",
    "music.drumTriangle": "(12) ट्रँगल",
    "music.drumVibraslap": "(17) व्हायब्रास्लॅप",
    "music.drumWoodBlock": "(10) वुड ब्लॉक",
    "music.instrumentBass": "(6) बास",
    "music.instrumentBassoon": "(14) बासून",
    "music.instrumentCello": "(8) सेलो",
    "music.instrumentChoir": "(15) गायकवृंद (Choir)",
    "music.instrumentClarinet": "(10) क्लॅरिनेट",
    "music.instrumentElectricGuitar": "(5) इलेक्ट्रिक गिटार",
    "music.instrumentElectricPiano": "(2) इलेक्ट्रिक पियानो",
    "music.instrumentFlute": "(12) बासरी",
    "music.instrumentGuitar": "(4) गिटार",
    "music.instrumentMarimba": "(19) मरिम्बा",
    "music.instrumentMusicBox": "(17) म्युझিক बॉक्स",
    "music.instrumentOrgan": "(3) ऑर्गन",
    "music.instrumentPiano": "(1) पियानो",
    "music.instrumentPizzicato": "(7) पिझिकाटो",
    "music.instrumentSaxophone": "(11) सॅक्सोफोन",
    "music.instrumentSteelDrum": "(18) स्टील ड्रम",
    "music.instrumentSynthLead": "(20) सिंथ लीड",
    "music.instrumentSynthPad": "(21) सिंथ पॅड",
    "music.instrumentTrombone": "(9) ट्रॉम्बोन",
    "music.instrumentVibraphone": "(16) व्हायब्राफोन",
    "music.instrumentWoodenFlute": "(13) लाकडी बासरी",

    // Pen
    "pen.categoryName": "पेन",
    "pen.clear": "सर्व पुसून टाका",
    "pen.stamp": "स्टँप",
    "pen.penDown": "पेन खाली",
    "pen.penUp": "पेन वर",
    "pen.setColor": "पेनचा रंग [COLOR] सेट करा",
    "pen.changeSize": "पेनचा आकार [SIZE] ने बदला",
    "pen.setSize": "पेनचा आकार [SIZE] वर सेट करा",
    "pen.colorMenu.color": "रंग",
    "pen.colorMenu.saturation": "सॅचुरेशन (Saturation)",
    "pen.colorMenu.brightness": "ब्राइटनेस (Brightness)",
    "pen.colorMenu.transparency": "पारदर्शकता",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "संगीत",
    "gui.extension.music.description": "वाद्ये आणि ड्रम वाजवा.",
    "gui.extension.pen.name": "पेन",
    "gui.extension.pen.description": "तुमच्या स्प्राइट्ससह चित्र काढा.",
    "gui.extension.videosensing.name": "व्हिडिओ सेन्सिंग",
    "gui.extension.videosensing.description": "कॅमेर्‍याने हालचाली ओळखा.",
    "gui.extension.poseface.name": "फेस सेन्सिंग",
    "gui.extension.poseface.description": "कॅमेर्‍याने चेहऱ्याची हालचाल ओळखा.",
    "gui.extension.posehand.name": "हँड सेन्सिंग",
    "gui.extension.posehand.description": "कॅमेर्‍याने हाताची हालचाल ओळखा.",
    "gui.extension.posebody.name": "बॉडी पोझ सेन्सिंग",
    "gui.extension.posebody.description": "कॅमेर्‍याने शरीराची हालचाल ओळखा.",
    "gui.extension.teachablemachine.name": "टीचेबल मशीन",
    "gui.extension.teachablemachine.description":
        "तुमच्या कॅमेर्‍याने सानुकूल मशीन लर्निंग मॉडेल्स वापरा.",
    "gui.extension.text2speech.name": "टेक्स्ट टू स्पीच",
    "gui.extension.text2speech.description": "तुमच्या प्रकल्पांना बोलतं करा.",
    "gui.extension.translate.name": "अनुवाद",
    "gui.extension.translate.description":
        "मजकुराचा अनेक भाषांमध्ये अनुवाद करा.",
    "gui.extension.makeymakey.name": "मेकी मेकी",
    "gui.extension.makeymakey.description": "कोणत्याही गोष्टीला की (Key) बनवा.",

    // Arduino Translations
    "arduinoUno.category.pins": "पिन",
    "arduinoUno.category.serial": "सिरीयल",
    "arduinoUno.category.data": "डेटा",

    "arduinoNano.category.pins": "पिन",
    "arduinoNano.category.serial": "सिरीयल",
    "arduinoNano.category.data": "डेटा",

    "arduinoLeonardo.category.pins": "पिन",
    "arduinoLeonardo.category.serial": "सिरीयल",
    "arduinoLeonardo.category.data": "डेटा",

    "arduinoMega2560.category.pins": "पिन",
    "arduinoMega2560.category.serial": "सिरीयल",
    "arduinoMega2560.category.data": "डेटा",

    "arduinoEsp32.category.pins": "पिन",
    "arduinoEsp32.category.serial": "सिरीयल",
    "arduinoEsp32.category.data": "डेटा",

    "arduinoEsp8266.category.pins": "पिन",
    "arduinoEsp8266.category.serial": "सिरीयल",
    "arduinoEsp8266.category.data": "डेटा",

    "arduinoK210.category.pins": "पिन",
    "arduinoK210.category.serial": "सिरीयल",
    "arduinoK210.category.data": "डेटा",

    "arduinoRaspberryPiPico.category.pins": "पिन",
    "arduinoRaspberryPiPico.category.serial": "सिरीयल",
    "arduinoRaspberryPiPico.category.data": "डेटा",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "इनपुट",
    "arduinoUno.modeMenu.output": "आउटपुट",
    "arduinoUno.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoUno.levelMenu.high": "हाय (High)",
    "arduinoUno.levelMenu.low": "लो (Low)",
    "arduinoUno.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoUno.pins.setDigitalOutput": "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoUno.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoUno.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoUno.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoUno.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoUno.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoUno.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoUno.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoUno.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoUno.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoUno.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "इनपुट",
    "arduinoNano.modeMenu.output": "आउटपुट",
    "arduinoNano.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoNano.levelMenu.high": "हाय (High)",
    "arduinoNano.levelMenu.low": "लो (Low)",
    "arduinoNano.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoNano.pins.setDigitalOutput": "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoNano.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoNano.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoNano.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoNano.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoNano.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoNano.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoNano.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoNano.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoNano.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoNano.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "इनपुट",
    "arduinoLeonardo.modeMenu.output": "आउटपुट",
    "arduinoLeonardo.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoLeonardo.levelMenu.high": "हाय (High)",
    "arduinoLeonardo.levelMenu.low": "लो (Low)",
    "arduinoLeonardo.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoLeonardo.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoLeonardo.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoLeonardo.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoLeonardo.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoLeonardo.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoLeonardo.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoLeonardo.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoLeonardo.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoLeonardo.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoLeonardo.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "इनपुट",
    "arduinoMega2560.modeMenu.output": "आउटपुट",
    "arduinoMega2560.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoMega2560.levelMenu.high": "हाय (High)",
    "arduinoMega2560.levelMenu.low": "लो (Low)",
    "arduinoMega2560.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoMega2560.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoMega2560.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoMega2560.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoMega2560.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoMega2560.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoMega2560.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoMega2560.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoMega2560.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoMega2560.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoMega2560.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoMega2560.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "इनपुट",
    "arduinoEsp32.modeMenu.output": "आउटपुट",
    "arduinoEsp32.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoEsp32.levelMenu.high": "हाय (High)",
    "arduinoEsp32.levelMenu.low": "लो (Low)",
    "arduinoEsp32.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoEsp32.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoEsp32.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoEsp32.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoEsp32.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoEsp32.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoEsp32.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoEsp32.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoEsp32.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoEsp32.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoEsp32.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoEsp32.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "इनपुट",
    "arduinoEsp8266.modeMenu.output": "आउटपुट",
    "arduinoEsp8266.modeMenu.inputPullup": "इनपुट-पुलअप",
    "arduinoEsp8266.levelMenu.high": "हाय (High)",
    "arduinoEsp8266.levelMenu.low": "लो (Low)",
    "arduinoEsp8266.pins.setPinMode": "पिन [PIN] मोड [MODE] सेट करा",
    "arduinoEsp8266.pins.setDigitalOutput":
        "डिजिटल पिन [PIN] आउट [LEVEL] सेट करा",
    "arduinoEsp8266.pins.setPwmOutput": "PWM पिन [PIN] आउट [OUT] सेट करा",
    "arduinoEsp8266.pins.readDigitalPin": "डिजिटल पिन [PIN] वाचा",
    "arduinoEsp8266.pins.readAnalogPin": "ॲनालॉग पिन [PIN] वाचा",
    "arduinoEsp8266.pins.setServoOutput": "सर्वो पिन [PIN] आउट [OUT] सेट करा",
    "arduinoEsp8266.pins.attachInterrupt": "इंटरप्ट पिन [PIN] मोड [MODE] जोडा",
    "arduinoEsp8266.pins.detachInterrupt": "इंटरप्ट पिन [PIN] काढा",
    "arduinoEsp8266.serial.serialBegin": "सिरीयल सुरू करा बॉडरेट [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "सिरीयल प्रिंट [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "सिरीयल उपलब्ध डेटा लांबी",
    "arduinoEsp8266.serial.serialReadAByte": "सिरीयल एक बाइट वाचा",
    "arduinoEsp8266.data.dataMap":
        "[DATA] ला ([ARG0], [ARG1]) पासून ([ARG2], [ARG3]) पर्यंत मॅप करा",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoUno.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoUno.dataTypeMenu.integer": "पूर्णांक",
    "arduinoUno.dataTypeMenu.decimal": "दशांश",
    "arduinoUno.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoNano.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoNano.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoNano.dataTypeMenu.integer": "पूर्णांक",
    "arduinoNano.dataTypeMenu.decimal": "दशांश",
    "arduinoNano.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoLeonardo.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoLeonardo.dataTypeMenu.integer": "पूर्णांक",
    "arduinoLeonardo.dataTypeMenu.decimal": "दशांश",
    "arduinoLeonardo.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoMega2560.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoMega2560.dataTypeMenu.integer": "पूर्णांक",
    "arduinoMega2560.dataTypeMenu.decimal": "दशांश",
    "arduinoMega2560.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoEsp32.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoEsp32.dataTypeMenu.integer": "पूर्णांक",
    "arduinoEsp32.dataTypeMenu.decimal": "दशांश",
    "arduinoEsp32.dataTypeMenu.string": "स्ट्रिंग",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] ला ([ARG0], [ARG1]) मध्ये मर्यादित करा",
    "arduinoEsp8266.data.dataConvert": "[DATA] ला [TYPE] मध्ये रुपांतरित करा",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] ला ASCII अक्षरात रुपांतरित करा",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] ला ASCII संख्येत रुपांतरित करा",
    "arduinoEsp8266.dataTypeMenu.integer": "पूर्णांक",
    "arduinoEsp8266.dataTypeMenu.decimal": "दशांश",
    "arduinoEsp8266.dataTypeMenu.string": "स्ट्रिंग",
    // Library manager & Board manager
    "gui.librariesBoardsTab": "लाइब्ररी",
    "gui.boardManagerTab": "बोर्ड मॅनेजर",

    "gui.boardManager.title": "बोर्ड मॅनेजर",
    "gui.boardManager.description":
        "अधिकृत Arduino बोर्ड शोधा आणि इंस्टॉल करा.",
    "gui.boardManager.searchPlaceholder": "Arduino बोर्ड शोधा (उदा: esp32)",
    "gui.boardManager.search": "शोधा",
    "gui.boardManager.searching": "शोधत आहे...",
    "gui.boardManager.advancedOptionsShow":
        "▶ प्रगत पर्याय (कस्टम इंस्टॉल पाथ)",
    "gui.boardManager.advancedOptionsHide": "▼ प्रगत पर्याय लपवा",
    "gui.boardManager.recommended": "शिफारस केलेले",
    "gui.boardManager.installed": "इंस्टॉल केले ({count})",
    "gui.boardManager.searchResults": "शोध परिणाम {count}",
    "gui.boardManager.refresh": "↻ रीफ्रेश",
    "gui.boardManager.refreshing": "↻ रीफ्रेश होत आहे...",

    "gui.libraryManager.title": "लाइब्ररी मॅनेजर",
    "gui.libraryManager.description":
        "अधिकृत Arduino लायब्ररी शोधा आणि इंस्टॉल करा.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino लायब्ररी शोधा (उदा: Servo)",
    "gui.libraryManager.search": "शोधा",
    "gui.libraryManager.searching": "शोधत आहे...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ प्रगत पर्याय (कस्टम इंस्टॉल पाथ)",
    "gui.libraryManager.advancedOptionsHide": "▼ प्रगत पर्याय लपवा",
    "gui.libraryManager.recommended": "शिफारस केलेले",
    "gui.libraryManager.installed": "इंस्टॉल केले ({count})",
    "gui.libraryManager.searchResults": "शोध परिणाम {count}",
    "gui.libraryManager.refresh": "↻ रीफ्रेश",
    "gui.libraryManager.refreshing": "↻ रीफ्रेश होत आहे...",
    "gui.gui.librariesBoardsTab": "लायब्ररी",
    "gui.gui.boardsManagerTab": "बोर्ड मॅनेजर",
};

export default mr;
